import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "D:\\orion-nextjs\\orion-nextjs\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\orion-nextjs\\orion-nextjs\\node_modules\\react-bootstrap\\esm\\Button.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\orion-nextjs\\orion-nextjs\\node_modules\\react-bootstrap\\esm\\Col.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\orion-nextjs\\orion-nextjs\\node_modules\\react-bootstrap\\esm\\Container.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\orion-nextjs\\orion-nextjs\\node_modules\\react-bootstrap\\esm\\Row.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\orion-nextjs\\orion-nextjs\\src\\components\\MotionComponents\\InventoryComp.js");
